import { UserFunctionsEnum, IconEnum, OptionMenuEnum } from '../enumerators/enumerators.enum';

export class MenuOption {


    moduleType: OptionMenuEnum = OptionMenuEnum.Screen;
    path: string = '';
    title: string = '';
    icon: string = 'fa-circle-o';
    homeScreen: boolean = false;
    isOpen: boolean = false;
    isActive: boolean = false;
    subMenu: Array<MenuOption> = [];
    order: number = 0;
    homeOrder: number = 0;
    description?: string = '';
    function: UserFunctionsEnum = UserFunctionsEnum.ChangePassword;

    constructor(init?: Partial<MenuOption>) {
        Object.assign(this, init);
    }

}
